<template>
  <div class="activity-page-container">
    <v-dialog v-model="loading" contained max-width="400" persistent class="custom-dialog">
      <v-card rounded="lg">
        <template #text>
          <div class="text-center pt-4">
            <v-progress-circular
              indeterminate
              color="primary"
              size="x-large"
              class="mb-4"
            />

            <div class="font-weight-bold mb-2">
              {{ $t('loadingActivity') }}
            </div>

            <v-progress-linear
              :model-value="progressValue"
              color="primary"
              height="2"
              class="mb-4"
              stream
            />
          </div>
        </template>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col>
        <Datepicker
          v-model="dateRange"
          range="true"
          label="Select range"
          variant="solo"
          :format="getDateFormat(locale)"
          @update:model-value="handleDateRangeChange"
          @cleared="handleDateRangeCleared"
          :dark="themeMode"
          :min-date="minDate"
          :max-date="maxDate"
          clearable
        ></Datepicker>
      </v-col>
    </v-row>

    <!-- Warning Alert -->
    <v-row v-if="showNoActivityWarning">
      <v-col>
        <v-alert
          type="warning"
          variant="tonal"
          border="start"
          closable
        >
          {{ $t('noActivityWarning', { 
            startDate: formatDateForDisplay(dateRange[0]), 
            endDate: formatDateForDisplay(dateRange[1]) 
          }) }}
        </v-alert>
      </v-col>
    </v-row>
    
    <v-row>
      <v-col cols="12" md="4">
        <StackedHorizontalBarChart
          :title="$t('itemBreakdown')"
          :exportFilename="$t('itemBreakdown') + '.png'"
          v-bind="activityCategoryChart"
          :filterContext="filterStatusHistoryContext"
          :chartFontColor="chartFontColor"
          :dataLoaded="dataLoaded"
          v-model:currentLevel="activityCategoryLevel"
        />
      </v-col>
      <v-col cols="12" md="4">
        <StackedHorizontalBarChart
          :title="$t('activityByTeam')"
          :exportFilename="$t('activityByTeam') + '.png'"
          v-bind="activityTeamsChart"
          :filterContext="filterStatusHistoryContext"
          :chartFontColor="chartFontColor"
          :dataLoaded="dataLoaded"
        />
      </v-col>
      <v-col cols="12" md="4">
        <StackedHorizontalBarChart
          :title="$t('activityByLocation')"
          :exportFilename="$t('activityByLocation') + '.png'"
          v-bind="activityLocationChart"
          :filterContext="filterStatusHistoryContext"
          :chartFontColor="chartFontColor"
          :dataLoaded="dataLoaded"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        <BaseTimeSeriesChart
          mode="periodic"
          :title="$t('velocityOverTime')"
          :infoText="$t('velocityTooltip')"
          :exportFilename="$t('rdriveVelocityChart') + '.png'"
          :bandTitles="bandTitles"
          :filterContext="filterStatusHistoryContext"
          :dataLoaded="dataLoaded"
          v-bind="velocityChart"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="12">
        <BaseTimeSeriesChart
          mode="cumulative"
          :title="$t('burnup.title')"
          :infoText="$t('burnup.tooltip')"
          :exportFilename="$t('rdriveBurndownChart') + '.png'"
          :bandTitles="bandTitles"
          :filterContext="filterStatusHistoryContext"
          :dataLoaded="dataLoaded"
          v-bind="burndownChart"
        />
      </v-col>
    </v-row>

    <!-- Items Data Table -->
    <v-row>
      <v-col cols="12" md="12">
        <v-skeleton-loader
          v-if="loading"
          type="table"
          height="400"
        ></v-skeleton-loader>
        <ItemsGrid v-else v-bind="grid" />
      </v-col>
    </v-row>
  </div>
</template>

<script src="./model.js"></script>
<style src="./style.css" scoped></style>
<style src="./global.css"></style>
